/**
 * tutorSlotMoveFormatter — ce que des créneaux choisis de « Garder son tuteur » réservent, dit une
 * seule fois : la question de confirmation l'annonce avant l'envoi, l'accusé s'en sert quand le
 * serveur ne le redit pas.
 */
import { type UITutorSlotMoveOption, type UITutorSlotMoveOutcome } from "../types"
import { joinFrench } from "./textFormatter"

/** Les créneaux choisis → la réservation qu'ils font : leurs libellés, le premier cours, leur nombre. */
export function bookedOutcomeOf(chosen: UITutorSlotMoveOption[]): Extract<UITutorSlotMoveOutcome, { kind: "booked" }> {
    return {
        kind: "booked",
        label: joinFrench(chosen.map((option) => option.label)),
        effectiveOn: chosen.map((option) => option.effectiveOn).sort()[0] ?? "",
        count: chosen.length,
    }
}
